import React from 'react';
import { styled } from 'linaria/react';
import { use100vh } from 'react-div-100vh';
import { SnackbarProvider } from 'fronton-react';
import { DataContext, TData } from 'entries/common/widgets/project-configuration/context';
import { Content } from './content';
import { useBreakpoints } from '../../common/hooks/use-breakpoints';
import { getPageDrawerHeight } from './helpers/get-page-drawer-height';

export const ProjectConfigurationPage = ({ data }: { data: TData }) => {
  const height = use100vh();
  const { mobile } = useBreakpoints() ?? {};
  const drawerHeight = getPageDrawerHeight({ type: data.type, isMobile: Boolean(mobile) });
  const calculatedHeight = height ? height - drawerHeight : `calc(100vh - ${drawerHeight}px)`;

  return (
    <DataContext.Provider value={data}>
      <SnackbarProvider>
        <Layout height={calculatedHeight}>
          <Container>
            <Content />
          </Container>
        </Layout>
      </SnackbarProvider>
    </DataContext.Provider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

const Layout = styled.div<{ height: number | string }>`
  width: 100%;
  height: ${props => props.height}px;
`;
